module.exports = __webpack_public_path__ + "static/media/oasis_cube_shop2.eca4a4e4.webp";